// extracted by mini-css-extract-plugin
export default {"label":"SectionLabel_label__koEs1","number":"SectionLabel_number__0MCrq","rule":"SectionLabel_rule__G0ZTh","invert":"SectionLabel_invert__x+1ZP"};